// 首页 系列
export { default as JoinUs } from 'lowcomp/plugins/index-series/JoinUs/indexS';
export { default as ListText } from 'lowcomp/plugins/index-series/list-text/indexS';
export { default as OurStory } from 'lowcomp/plugins/index-series/OurStory/indexS';
export { default as ProductScenario } from 'lowcomp/plugins/index-series/ProductScenario/indexS';
export { default as PrroductScenarioRound } from 'lowcomp/plugins/index-series/PrroductScenarioRound/indexS';
export { default as PrroductScenarioSlide } from 'lowcomp/plugins/index-series/PrroductScenarioSlide/indexS';
export { default as RewardLists } from 'lowcomp/plugins/index-series/RewardLists/indexS';
export { default as ServiceModule } from 'lowcomp/plugins/index-series/ServiceModule/indexS';
// export { default as IndexLargeCardJP } from 'lowcomp/plugins/index-series/index-large-card-jp/indexS';
export { default as IndexGlobalSitePopup } from 'lowcomp/plugins/index-series/index-global-site-popup/indexS';

// 首页 v3
export { default as IndexBannerSwiper } from 'lowcomp/plugins/index-v3/index-banner-swiper/indexS';

export { default as IndexCommonCard } from 'lowcomp/plugins/index-v3/index-common-card/indexS';

export { default as IndexJoinEmail } from 'lowcomp/plugins/index-v3/index-join-email/indexS';

export { default as IndexListB1 } from 'lowcomp/plugins/index-v3/index-list-b1/indexS';

export { default as IndexListC1 } from 'lowcomp/plugins/index-v3/index-list-c1/indexS';

export { default as IndexListD1 } from 'lowcomp/plugins/index-v3/index-list-d1/indexS';

export { default as IndexSwiperA1 } from 'lowcomp/plugins/index-v3/index-swiper-a1/indexS';

export { default as IndexSwiperB1 } from 'lowcomp/plugins/index-v3/index-swiper-b1/indexS';

export { default as IndexTabListA } from 'lowcomp/plugins/index-v3/index-tab-list-a/indexS';

export { default as ImageBackgroundCard } from 'lowcomp/plugins/index-v3/image-background-card/indexS';
